<template>
  <div class="content">
    <div class="title">购买无限卡家庭卡审核进度</div>
    <!-- 没有审核记录 -->
    <van-empty
      class="custom-image"
      v-if="noData"
      image="https://img-ylsn-test.ylyk.com/server/image/course/2025_10_22_1761115604173.png"
      :description="description"
    />
    <div class="step_list" v-cloak v-else>
      <div class="flexbox step_item">
        <img src="https://img-cdn1.ylyk.com/image/1658453704533_m1658424790000_s5048.jpg" />
        <div class="step_item_info">
          <div class="item_title">您已提交申请</div>
          <div class="item_date">{{ parseDate(ExamineData.createTime) }}</div>
          <div class="item_error"></div>
        </div>
      </div>
      <div class="step_line_box"></div>
      <div class="flexbox step_item">
        <img v-if="status === -1" src="https://img-cdn1.ylyk.com/image/1658304999628_m1658276088000_s5588.jpg" />
        <img v-if="status === 0" src="https://img-cdn1.ylyk.com/image/1658304999628_m1658276088000_s5684.jpg" />
        <img v-if="status === 1" src="https://img-cdn1.ylyk.com/image/1658453704533_m1658424790000_s6142.jpg" />
        <img
          v-if="status === 2 || status === 3"
          src="https://img-cdn1.ylyk.com/image/1658453704533_m1658424790000_s6259.jpg"
        />
        <div class="step_item_info" :class="status >= 0 ? 'yes' : 'no'">
          <div class="item_title" v-if="status === 1">审核通过&权益已开通</div>
          <div class="item_title" v-if="status === 2">审核失败</div>
          <div class="item_title" v-if="status === 3">审核已关闭</div>
          <div class="item_title" v-if="status <= 0">审核中</div>
          <div class="item_date">
            {{ parseDate(ExamineData.updateTime) || '' }}
          </div>
          <div class="item_error" v-if="status === 2">未通过审核原因：{{ ExamineData.note }}</div>
        </div>
      </div>
    </div>
    <!-- https://img-ylsn-test.ylyk.com/server/image/course/2025_10_22_1761115604173.png -->
    <div class="flexbox bottom_btn_box" v-cloak v-if="!noData">
      <div v-if="status === 2" @click="goApply">重新提交申请</div>
      <div v-else @click="gocommitmentPage">查看承诺书</div>
    </div>
    <van-action-sheet :close-on-click-overlay="false" v-model="actionShow" title="请选择子账号查看审核进度">
      <ul class="acount_list_box">
        <li class="flexbox item_box" @click="onSelect(item)" v-for="(item, index) in actionsList" :key="index">
          <span>{{ item.destMobile }}</span>
          <div>{{ parseDate(item.createTime) }}</div>
          <img src="../../../../images/subVIp/right.png" alt="" />
        </li>
        <li class="item_padding_box"></li>
      </ul>
    </van-action-sheet>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      noData: false,
      ExamineData: {
        createTime: '',
        receiveCommitTime: '',
        note: '',
        commitmentUrl: '',
        id: null
      },
      actionShow: false,
      actionsList: [],
      description: '未查询到审核信息'
    }
  },
  computed: {
    status() {
      const { ExamineData } = this
      return ExamineData.examineStatus >= 0 ? ExamineData.examineStatus : -1
    }
  },
  created() {
    this.init()
  },
  methods: {
    onSelect(item) {
      this.actionShow = false
      this.getInfo(item.id)
    },
    init() {
      this.$store.dispatch('goods/vip/subVipExamineList').then(res => {
        console.log('家庭卡记录', res)
        if (res.length === 0) {
          this.noData = true
        } else if (res.length === 1) {
          this.getInfo(res[0].id)
        } else {
          this.noData = true
          this.actionsList = res
          this.actionShow = true
          console.log('多条记录')
        }
      })
    },
    parseDate(str) {
      if (str) {
        return new Date(str).toFormattedString('yyyy年MM月dd日 hh:mm')
      }
    },
    // 根据ID获取卡夫审核详情
    getInfo(id) {
      this.$store.dispatch('goods/vip/subVipExamineInfo', { id }).then(res => {
        this.noData = false
        this.ExamineData = Object.assign({}, res)
      })
    },
    upData() {
      const commitmentUrl = this.ExamineData.commitmentUrl
      this.$store.commit('goods/vip/saveCommitmentDetails', { commitmentUrl })
    },
    gocommitmentPage() {
      this.upData()
      this.$router.push({
        path: 'subVip-commitmentView',
        query: {
          id: this.ExamineData.id
        }
      })
    },
    goApply() {
      this.upData()
      this.$router.push({
        path: 'subVip-submitDetails',
        query: {
          id: this.ExamineData.id
        }
      })
    }
  }
}
</script>
<style>
[v-cloak] {
  display: none;
}
</style>
<style lang="less" scoped>
.acount_list_box {
  padding-bottom: 0.38rem;
}
.item_padding_box {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.item_box {
  font-size: 0.28rem;
  border-bottom: 1px solid #eee;
  padding: 0.24rem 0.32rem;
  justify-content: space-between;
  div {
    margin-right: 10%;
  }
  img {
    display: block;
    width: 0.24rem;
    height: 0.24rem;
  }
}
// .item_border::after {
//   content: "";
// display: block;
//   position: absolute;
//   top: 43%;
//   right:0.3rem;
//   transform: translateY(-50%);
// border-top: 1px solid #333;
// border-right: 1px solid #333;
//   transform: rotate(45deg);
//   width: 6px;
//   height: 6px;
// }
.custom-image {
  padding-top: 3rem;
  /deep/ .van-empty__image {
    display: block;
    width: 3.92rem;
    height: auto;
  }
}
img {
  display: block;
}
.content {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f7f9fb;
  padding: 0.48rem 0.32rem;
}
.title {
  font-size: 0.32rem;
  font-weight: 600;
  color: #000000;
  padding-bottom: 0.56rem;
}
.step_line_box {
  width: 1px;
  height: 0.84rem;
  background-color: #999;
  margin: 0.18rem 0 0.18rem 0.56rem;
}
.step_list {
  padding: 0.56rem 0 0.2rem 1.32rem;
}
.step_item {
  align-items: flex-start;
}
.step_item img {
  flex-shrink: 0;
  width: 1.12rem;
  height: 1.12rem;
  margin-right: 0.28rem;
}
.step_item_info {
  flex: auto;
  padding-top: 0.24rem;
}
.yes {
  /* background-color: ; */
}
.no {
  opacity: 0.5;
}
.item_title {
  font-size: 0.28rem;
  font-weight: 600;
  color: #000000;
  margin-bottom: 0.12rem;
}
.item_date {
  font-size: 0.2rem;
  color: #888888;
  margin-bottom: 0.24rem;
}
.item_error {
  font-size: 0.24rem;
  color: #c35151;
}
.item_success {
  font-size: 0.24rem;
  color: #00b25a;
}

.bottom_btn_box {
  position: fixed;
  width: 100%;
  padding: 0.32rem 0 1rem;
  left: 0;
  bottom: 0;
  background-color: #fff;
  box-shadow: 0rpx -4px 0.2rem 0rpx rgba(0, 0, 0, 0.06);
}
.bottom_btn_box div {
  width: 6.54rem;
  height: 0.88rem;
  background: #00b25a;
  border-radius: 0.08rem;
  margin: 0 auto;
  font-size: 0.32rem;
  font-weight: 600;
  color: #ffffff;
  justify-content: center;
  text-align: center;
  line-height: 0.88rem;
}
</style>
